
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "@/core/services/ApiService";
import { flagUrl, countryName } from "./countries";

interface RankingGroup {
  id: number;
  name: string;
  tag: string;
  icon_path: string | null;
  country: string;
  members_count: number;
  points: number;
}

export default defineComponent({
  name: "GroupRanking",
  setup() {
    const loading = ref(true);
    const ranking = ref<RankingGroup[]>([]);

    onMounted(async () => {
      try {
        const { data } = await ApiService.get("groups/ranking");
        ranking.value = (data as RankingGroup[]).filter(
          (group) => Number(group.points) > 0
        );
      } finally {
        loading.value = false;
      }
    });

    return { loading, ranking, flagUrl, countryName };
  },
});
